import { twMerge } from 'tailwind-merge';

import { BasicButton } from 'routes/staking_v2/components/BasicButton';
import { InfoTooltip } from 'routes/staking_v2/components/InfoTooltip';

type ClaimRewardButtonProps = {
  onClick: () => void;
  disabled: boolean;
  countdownText: string;
  tooltipText?: string;
};

export const ClaimRewardButton = ({ onClick, disabled, countdownText, tooltipText }: ClaimRewardButtonProps) => {
  const content = tooltipText || countdownText;
  const isTooltipVisible = disabled && content;
  return (
    <div className="tw-flex tw-items-center tw-gap-[6px]">
      <BasicButton
        text="Claim Reward"
        onClick={disabled ? undefined : onClick}
        disabled={false}
        ariaDisabled={disabled}
        className={twMerge('tw-h-[36px] tw-w-[118px] tw-px-[0px]', isTooltipVisible ? 'tw-w-[143px]' : 'tw-w-[118px]')}
        textClassName="tw-text-[14px]"
        rightIcon={isTooltipVisible && <InfoTooltip content={content} size={18} position="top" width={220} />}
      />
    </div>
  );
};
